import color from 'tinycolor2'
import { colors, colorsLight } from '@PipelineDeals/shared-react-components'

export const updatedEventFromDropped = ({ event, start, end, allDay }) => {
  if (event.attributes.type === 'CalendarEvent') {
    return {
      updateAttributes: {
        start_time_date: start.toDateString(),
        start_time_time: start.toTimeString(),
        end_time_date: end.toDateString(),
        end_time_time: end.toTimeString()
      },
      eventReplace: {
        ...event.attributes,
        system_start_time_date: start,
        system_end_time_date: end
      }
    }
  } else if (event.attributes.type === 'CalendarTask') {
    return {
      updateAttributes: {
        due_date: start.toDateString()
      },
      eventReplace: {
        ...event.attributes,
        system_start_time_date: start,
        system_end_time_date: end
      }
    }
  }
}

export const getDefaultFilter = (userId) => ({
  id: null,
  user_ids: [userId],
  user_colors: {},
  event_type_ids: [],
  event_type_colors: {}
})

export const colorStylesForUser = ({ userColors, userId }) => {
  const selectedColor = userColors[userId]
  const defaultBackgroundColor = colors.blue[100]

  return colorStylesData({ selectedColor, containerBackgroundColor: defaultBackgroundColor })
}

export const colorStylesForEventType = ({ eventTypeColors, category, eventTypeId, containerBackgroundColor }) => {
  const colorId = eventTypeId ? `${category}_${eventTypeId}` : category
  const selectedColor = eventTypeColors[colorId] || eventTypeColors[category]

  return colorStylesData({ selectedColor, containerBackgroundColor })
}

const colorStylesData = ({ selectedColor, containerBackgroundColor }) => {
  const backgroundColor = selectedColor || containerBackgroundColor
  const colorPickerColorBackgroundColor = selectedColor || colors.gray[100]

  const textColor = color(backgroundColor).isLight()
    ? colorsLight.blue[700]
    : colorsLight.white

  return {
    colorPickerBackgroundColor: colorPickerColorBackgroundColor,
    backgroundColor,
    color: textColor
  }
}
